import { render, staticRenderFns } from "./MyRequestList.vue?vue&type=template&id=67748c1e&scoped=true"
import script from "./MyRequestList.vue?vue&type=script&lang=ts"
export * from "./MyRequestList.vue?vue&type=script&lang=ts"
import style0 from "./MyRequestList.vue?vue&type=style&index=0&id=67748c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67748c1e",
  null
  
)

export default component.exports